import { getFormattedStreet } from "./address-format.util"

// One row per comparable field. `name` is the PATCH key the document editor
// already sends; `inputId` is the DOM id the client modal fills. Keeping both
// here is what lets the two callers share this function without either of them
// translating keys.
const FIELDS = [
  { key: "street", name: "contact.invoice_address.street", inputId: "address_street", label: "street" },
  { key: "postal_code", name: "contact.invoice_address.postal_code", inputId: "address_postal_code", label: "postalCode" },
  { key: "city", name: "contact.invoice_address.city", inputId: "address_city", label: "city" },
  { key: "name", name: "contact.invoice_address.name", inputId: "address_name", label: "name" },
  { key: "tax_id", name: "contact.tax_id", inputId: "party_tax_id", label: "taxId" },
  { key: "vat_id", name: "contact.vat_id", inputId: "party_vat_id", label: "vatId" }
]

function parseDate(dateStr) {
  if (!dateStr) return null
  return new Date(dateStr)
}

function isDateInRange(date, validFrom, validTo) {
  // Normalize all dates to midnight (ignore time)
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  const from = new Date(validFrom)
  from.setHours(0, 0, 0, 0)
  const to = validTo ? new Date(validTo) : null
  if (to) to.setHours(0, 0, 0, 0)

  if (to == null && d >= from) return true
  return from <= d && d <= to
}

function addressValidAt(register, referenceDate) {
  let regAddress = null
  if (Array.isArray(register.all_addresses)) {
    regAddress =
      register.all_addresses.find((addr) => {
        const validFrom = parseDate(addr.valid_from)
        const validTo = parseDate(addr.valid_to)
        return isDateInRange(referenceDate, validFrom, validTo)
      }) || register.all_addresses[0] // fallback to first if none match
  }
  return regAddress
}

function nameValidAt(register, referenceDate) {
  let regName = null
  if (Array.isArray(register.all_names)) {
    regName =
      register.all_names.find((n) => {
        const validFrom = parseDate(n.valid_from)
        const validTo = parseDate(n.valid_to)
        return isDateInRange(referenceDate, validFrom, validTo)
      }) || register.all_names[register.all_names.length - 1] // fallback to last if none match
  }
  return regName
}

// Returns the register values for the six comparable fields at referenceDate,
// flattening the historical rows down to plain strings.
function registerValues(register, referenceDate) {
  const address = addressValidAt(register, referenceDate)
  const nameRow = nameValidAt(register, referenceDate)
  let postalCode = address
    ? Array.isArray(address.postal_codes)
      ? address.postal_codes[0]
      : address.postal_code
    : Array.isArray(register.postal_codes)
      ? register.postal_codes[0]
      : register.postal_code
  if (postalCode) postalCode = postalCode.replace(/\s+/g, "")

  return {
    street: address
      ? getFormattedStreet(address.municipality, address.street, address.reg_number, address.building_number)
      : getFormattedStreet(register.municipality, register.street, register.reg_number, register.building_number),
    postal_code: postalCode,
    city: address ? address.municipality : register.municipality,
    name: nameRow ? nameRow.name : register.company_name,
    tax_id: register.tax_id,
    vat_id: register.vat_id
  }
}

export function diffRegisterRecord({ register, company, referenceDate, labels }) {
  if (!register) return []

  const values = registerValues(register, referenceDate)

  return FIELDS.flatMap((field) => {
    const next = values[field.key]
    const current = company[field.key]
    if (!next || next === current) return []

    return [{ label: labels[field.label], name: field.name, inputId: field.inputId, current, register: next }]
  })
}
